const STORAGE_KEY = 'acctbridge-theme'

export function initTheme(toggleBtn: HTMLButtonElement): void {
  const saved = localStorage.getItem(STORAGE_KEY) as 'light' | 'dark' | null
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
  const initial: 'light' | 'dark' = saved ?? (prefersDark ? 'dark' : 'light')
  applyTheme(initial, toggleBtn)

  toggleBtn.addEventListener('click', () => {
    const current = document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light'
    const next: 'light' | 'dark' = current === 'dark' ? 'light' : 'dark'
    applyTheme(next, toggleBtn)
    localStorage.setItem(STORAGE_KEY, next)
  })
}

function applyTheme(theme: 'light' | 'dark', toggleBtn: HTMLButtonElement): void {
  document.documentElement.dataset.theme = theme
  toggleBtn.textContent = theme === 'dark' ? '☀' : '🌙'
}
